import { compose, createStore } from 'redux';
import itemReducer from './reducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
const windowobj:any=window
const persistConfig = {
    key: 'root',
    storage,
  };
  
  // Wrap the root reducer with persistReducer
  const persistedReducer = persistReducer(persistConfig, itemReducer);

const composeEnhancers = windowobj?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore( persistedReducer,composeEnhancers());

const persistor = persistStore(store);

export { store, persistor };
